import * as React from "react";
import DropdownSwitcher from "views/components/visualizations/OnClickPopover/DropdownSwitcher";
const dropdownPopover = (Component) => ({ anchor, config, onPopoverClose }) => /* @__PURE__ */ React.createElement(
  DropdownSwitcher,
  {
    component: Component,
    clickPoint: anchor.pt,
    config,
    clickPointsInRadius: anchor.pointsInRadius,
    onPopoverClose
  }
);
export default dropdownPopover;
